import Swiper from 'swiper/bundle';
( function() {

  const lessons = document.querySelectorAll('.lesson-history__list > dt');

  if (lessons.length > 0) {

    let opens;

    Array.prototype.forEach.call(lessons, function(lesson) {
      lesson.addEventListener('click', function() {

        let key = 'opened';

        let current = this.classList.contains(key);

        opens = document.querySelectorAll('.' + key);

//        if (opens.length > 0) {
//          Array.prototype.forEach.call(opens, function(opened) {
//            opened.classList.remove(key);
//          });
//        }

        if (current) {
          this.classList.remove(key);
        } else {
          this.classList.add(key);
        }
      });
    });

  }
}() );
